
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'Gemini 專案',
	'appExit': '跳至「歡迎使用」頁面',


	'widgetsListLabel': '小組件清單。選取一個小組件，然後按 Enter 鍵進行新增。',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': '保持最新',
	'dirty': '未保持最新',
	'conflict': '儲存視圖時發生衝突',
	'error': '儲存視圖時發生問題',
	'failure': '無法聯絡伺服器',
	'saveFailed': '無法儲存視圖',

	'wa_insync': '已儲存',
	'wa_conflict': '儲存視圖時發生衝突',
	'wa_error': '無法儲存視圖',
	'wa_failure': '無法聯絡伺服器',

	// Menu Labels
	'changeDisplay': '變更顯示',
	'changeToColumnChart': '變更為直條圖',
	'changeToBubbleChart': '變更為泡泡圖',
	'toggleMoveHandles': '切換移動控點',
	'undo': '復原',
	'redo': '重做',
	'mode': '變更模式',

	'untitled': '未命名',
	'remove': '移除',
	'editTitle': '編輯標題',
	'edit': '編輯',
	'done': '完成',

	// Data tray
	'dataTrayHandleOpenLabel': '開啟資料匣',
	'dataTrayHandleCloseLabel': '關閉資料匣',

	// Dialogs
	'dlg_loading': '載入中...',
	'dlg_ok': '確定',
	'dlg_create': '建立',
	'dlg_cancel': '取消',
	'dlg_close': '關閉',
	'dlg_update': '更新',
	'dlg_renameBoardTitle': '重新命名此物件',
	'dlg_renameDatasetTitle': '重新命名此資料集',
	'dlg_renameSceneTitle': '重新命名此場景',
	'dlg_NameLabel': '名稱：',
	'dlg_NewNameLabel': '新名稱：',
	'dlg_DefaultNameWithDataSet': '%{name} 視圖',
	'dlg_ShareTitle': '共用內容',
	'dlg_UnshareTitle': '移除內容共用',
	'dlg_ShareUser': '使用者 ID：',
	'dlg_NewColumnLabel': '新計算名稱',

	'dlg_new': '新建...',
	'dlg_open': '開啟...',
	'dlg_makeACopy': '製作副本',
	'dlg_rename': '重新命名...',
	'dlg_moreToCome': '將會有更多的動作...',

	'dlg_use': '使用',

	'dlg_RelinkDatasetTitle': '將資料集 \'%{datasetName}\' 取代為 ...',

	'open_error': '開啟視圖時發生問題。',

	// Delete Board
	'del_dialogTitle': '確認刪除',
	'del_itemMsg': '您確定要刪除 \'%{name}\' 嗎？',
	'del_itemsMsg': '您確定要刪除 %{count} 個項目嗎？',
	'del_deleteErr': '無法刪除 \'%{name}\'',

	// List Sorting
	'dlg_ascending': '遞增',
	'dlg_descending': '遞減',
	'dlg_custom': '自訂',
	'dlg_none': '無',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': '搜尋',

	'searchHint': '搜尋所有資料',
	'clearSearchResult': '清除搜尋結果',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': '圓形',
	'shapesHexagon': '六角形',
	'shapesLine': '折線圖',
	'shapesOctagon': '八角形',
	'shapesPentagon': '五角形',
	'shapesSquare': '方形',
	'shapesTriangle': '三角形',
	'shapesDiamond': '菱形',
	'shapesTitle': '形狀內容', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': '圓角方形',
	'shapesStar': '星形',
	'shapesChevron': '人字紋',
	'shapesBadge_ribbon': '識別證緞帶',
	'shapesBadge': '識別證',
	'shapesHeart': '心形',
	'shapesExclamation': '驚嘆號',
	'shapesTrendingup': '往上',
	'shapesTrendingdown': '往下',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': '人員',
	'shapesFemale': '女性',
	'shapesHappyface': '快樂的臉',
	'shapesMale': '男性',
	'shapesMan': '男人',
	'shapesNeutralface': '沒有表情的臉',
	'shapesSadface': '悲傷的臉',
	'shapesShakehands': '握手',
	'shapesThumbsdown': '很遜',
	'shapesThumbsup': '很讚',
	'shapesWoman': '女人',

	// Weather and places
	'shapesPlacesWeatherCat': '位置和天氣',
	'shapesCity': '城市',
	'shapesCloud': '雲',
	'shapesEducation': '教育',
	'shapesGovernment': '政府',
	'shapesHalfcloud': '半雲',
	'shapesHouse': '房形',
	'shapesMoon': '月亮',
	'shapesRain': '有雨',
	'shapesSunny': '晴',

	//Vehicles
	'shapesVehiclesCat': '車輛',
	'shapesAirplane': '飛機',
	'shapesCar': '汽車',
	'shapesShip': '船',
	'shapesShoppingcart': '購物車',
	'shapesTrain': '火車',
	'shapesTruck': '卡車',

	//Objects
	'shapesObjectsCat': '物件',
	'shapesBook': '書籍',
	'shapesBriefcase': '公事包',
	'shapesCalendar': '行事曆',
	'shapesCheck': '支票',
	'shapesClock': '時鐘',
	'shapesDesktop': '桌上型電腦',
	'shapesDocument': '文件',

	'shapesFood': '食物 ',
	'shapesGear': '齒輪',
	'shapesHealth': '健康',

	'shapesIdea': '構想',
	'shapesMobile': '行動裝置',
	'shapesMoney_bill': '紙幣',
	'shapesMoney_coin': '硬幣',
	'shapesPiggybank': '撲滿',
	'shapesStackofpaper': '一疊紙',
	'shapesStickynote1': '自黏便箋 1',
	'shapesStickynote2': '自黏便箋 2',
	'shapesTarget': '目標',
	'shapesTool': '工具',

	'shapesUmbrella': '雨傘',

	'shapesBrain': '大腦',
	'shapesSkull': '頭顱',
	'shapesEye': '眼睛',

	// Arrows shapes
	'shapesArrowsCat': '箭頭',
	'shapesRightArrow': '向右箭頭',
	'shapesLeftArrow': '向左箭頭',
	'shapesDoubleArrow': '雙向箭頭',
	'shapesCurvedArrow': '彎曲箭頭',

	// Callouts shapes
	'shapesCalloutsCat': '圖說文字',
	'shapesRectCallout': '圖說文字',

	// Images
	'imagesCat': '影像',
	'imageWidgetTitle': '映像檔小組件',
	'imgUrl': '影像 URL',
	'noImgSelected': '未選取任何影像',
	'enterImgUrl': '在這裡輸入影像 URL',
	'imgPasteLink': '貼上 URL，然後按 Enter 鍵來進行儲存。',
	'imgResizeToFit': '調整大小以符合影像大小',
	'imgHeight': '高度：',
	'imgWidth': '寬度：',
	'imgTransparency': '透通性：',
	'imgMissingUrl': '影像 URL 遺漏。',
	'imgUrlValidationError': '影像 URL 無效。',
	'imgUrlInvalidDomainError': '此影像 URL 指向尚未由管理者核准的網域。由管理者核准的網域為 "%{domains}"。',

	// line shape
	'propStrokeWidth': '線條寬度',
	'propStrokeDashArray': '線條樣式',
	'propStrokeSolidline': '實線',
	'propStrokeLineCap': '線蓋',
	'propStrokeLineCapButt': 'Butt（預設值）',
	'propStrokeLineCapRound': '圓形',
	'propStrokeLineCapSquare': '方形',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': '播放',
	'dataPlayerValueListLabel': '資料播放程式值',
	// Text Widget
	'textWidgetTitle': '文字小組件',
	'textStyle': '樣式',
	'textStyleDescription': '預先格式化文字樣式',
	'textTitleStyle': '標題',
	'textTitleSmallStyle': '小型標題',
	'textSubtitleStyle': '子標題',
	'textBodyStyle': '主體',
	'textBodySmallStyle': '小型主體',
	'textCaptionStyle': '標題',
	'textQuoteStyle': '引用',
	'textQuoteSmallStyle': '小型引用',
	'textResponsiveStyle': '自動調整大小',
	'textAutoFontSize': '自動',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': '髮絲',
	'textFontFamilySubClassThin': '特細',
	'textFontFamilySubClassThinItalic': '特細斜體',
	'textFontFamilySubClassExtraLight': '非常細',
	'textFontFamilySubClassExtraLightItalic': '非常細斜體',
	'textFontFamilySubClassLight': '明亮',
	'textFontFamilySubClassLightItalic': '細斜體',
	'textFontFamilySubClassRegular': '標準',
	'textFontFamilySubClassRegularItalic': '標準斜體',
	'textFontFamilySubClassItalic': '斜體',
	'textFontFamilySubClassMedium': '中',
	'textFontFamilySubClassMediumItalic': '中等斜體',
	'textFontFamilySubClassHeavy': '特粗',
	'textFontFamilySubClassHeavyItalic': '特粗斜體',
	'textFontFamilySubClassDemiBold': '半粗體',
	'textFontFamilySubClassDemiBoldItalic': '半粗斜體',
	'textFontFamilySubClassBold': '粗體',
	'textFontFamilySubClassBoldItalic': '粗斜體',
	'textFontFamilySubClassExtraBold': '非常粗',
	'textFontFamilySubClassExtraBoldItalic': '非常粗斜體',
	'textFontFamilySubClassBlack': '黑色',
	'textFontFamilySubClassBlackItalic': '特黑斜體',
	'textFontFamilySubClassStencil': '模板字體',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': '自動調整大小字型',
	'responsiveCoachmarkContents': '當您在調整文字類型大小時自動將字型調整至適當大小。您可以在文字內容中設定字型大小。',

	'propText': '文字詳細資料', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': '文字內容', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': '字型大小',
	'textFontFamily': '字型系列',
	'textFontWeight': '字型加權', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Widget Properties
	'propImageLink': '影像鏈結',
	'propMissingURL': '輸入 URL',
	'propImgTop': '影像內容', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': '一般內容', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': '一般', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': '一般', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': '填入顏色', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': '文字顏色', // TODO: becomes "Color" when FF 'PropertiesV2' is enabled
	'propBorderColor': '邊框顏色',
	'propMaintainAxisScales': '維護軸刻度',
	'propShowItemLabel': '顯示項目標籤',
	'propHideLegend': '隱藏圖註',
	'propColorPalette': '選用區',
	'propLegendPosition': '圖註位置',
	'propHideAxisTitleLabels': '隱藏軸標題',
	'propLineColor': '折線圖顏色',
	'propBubbleColor': '泡泡顏色',
	'propInterpolation': '平滑線條',
	'propElementColor': '視覺化元素顏色',
	'propSymbolShape': '符號形狀',
	'propHeatScalePalette': '顏色順序',
	'propHeatScalePalette_tooltipDarkerForLowerValue': '更深的顏色代表較小值。',
	'propHeatScalePalette_tooltipDarkerForHigherValue': '更深的顏色代表較大值。',
	'propImageDetails': '映像檔詳細資料', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': '網頁詳細資料', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': '媒體詳細資料', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': '輸入 URL，然後按 Enter 鍵。',

	//Layout Properties
	'sectionName_positionAndStyle': '位置和樣式',
	'propPositionLabel': '位置', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis': 'X', // TODO: becomes 'X position' when FF 'PropertiesV2' is enabled
	'propPositionYAxis': 'Y', // TODO: becomes 'Y position' when FF 'PropertiesV2' is enabled
	'propResizeLabel': '大小', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth': '寬度',
	'propResizeHeight': '高度',
	'propRotateLabel': '旋轉',
	'propRotateAngle': '角度', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': '圖示數量',
	'propScaleDescription': '選取圖示數量',
	'propScaleFew': '低',
	'propScaleDefault': '預設',
	'propScaleMany': '高',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': '此值必須為數字',

	'mediaAriaLabel': 'URL 輸入',
	'dropdownAriaLabel' : '下拉',
	'ariaGroupLabel': '下拉清單種類：%{cateoryLabel} item: %{itemLabel}。按「向下鍵」以展開。按「向上鍵」和「向下鍵」進行導覽，或按「跳出鍵」以收合。',

	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': '前次重新整理時間：%{timeInterval} 前',
	'widgetTimer': '小組件計時器',

	// Theme colors
	'transparent': '沒有顏色',
	'white': '白色',
	'lightGrey': '淺灰色',
	'grey': '灰色',
	'darkGrey': '深灰色',
	'black': '黑色',
	'lightBlue': '淺藍色',
	'blue': '藍色',
	'darkBlue': '深藍色',
	'yellow': '黃色',
	'orange': '橙色',
	'lime': '萊姆色',
	'green': '綠色',
	'peach': '桃紅色',
	'red': '紅色',
	'violet': '紫羅蘭色',
	'aqua': '水藍色',
	'purple': '紫色',
	'plum': '深紫色',
	'gray10': '灰色 10',
	'gray20': '灰色 20',
	'gray30': '灰色 30',
	'gray50': '灰色 50',
	'gray60': '灰色 60',
	'gray70': '灰色 70',
	'gray80': '灰色 80',
	'gray90': '灰色 90',
	'gray100': '灰色 100',
	'blue50': '藍色 50',
	'blue60': '藍色 60',
	'blue70': '藍色 70',
	'green40': '綠色 40',
	'green50': '綠色 50',
	'red50': '紅色 50',
	'red60': '紅色 60',


	//Theme Palette Label
	'paletteLabel': 'IBM 選用區 %{number}',
	'heatPaletteLabel': 'IBM 熱圖選用區 %{number}',
	'conditionalPaletteLabel': 'IBM 條件式選用區 %{number}',
	'carbonPaletteXLight': '副本 X 亮',
	'carbonPaletteXDark': '副本 X 暗',
	'carbonPalettePurple': '紫色',
	'carbonPaletteTeal': '深藍綠色',
	'carbonPaletteCyan': '青藍色',
	'carbonPaletteMagenta': '紫紅色',
	'carbonPalettePurpleTeal': '紫色/深藍綠色',
	'carbonPaletteCyanMagenta': '青藍/紫紅色',
	'carbonPaletteGreenRed': '綠/紅',
	'carbonPaletteGreenYellowRed': '綠/黃/紅',
	'carbonPalettePurpleTealConvergent': '紫色/深藍綠色聚合',
	'carbonPaletteCyanMagentaConvergent': '青藍/紫紅色聚合',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM 淺色選用區',
	'userPaletteColor_defaultTheme': 'IBM 預設選用區',
	'userPaletteColor_darkTheme': 'IBM 深色選用區',

	// Dashboard
	'propDashboardBackgroundColor': '背景顏色',
	'propLayoutPositioning': '佈置定位',
	'propLayoutRelative': '相對',
	'propLayoutAbsolute': '絕對值',
	'propLayoutPositioningCoachmarkTitle': '選取佈置樣式',
	'propLayoutPositioningCoachmarkContent': '在相對版面中，小組件的大小和位置會調整以符合畫面大小。無論畫面大小如何，絕對佈置中的小組件就是您在視圖中調整並放置的樣子。',
	'gridText': '顯示網格',
	'snapText': '貼齊格線',
	'snapObjectsText': '貼齊物件',
	'fitPageText': '適合頁面',
	'gridLabel': '網格',
	'heightUnit': 'h',
	'widthUnit': 'w',
	'pixelUnit': 'px',
	'propPageSizeLabel': '頁面大小',
	'propPageSizePresetAriaLabel': '頁面大小預設',
	'propPageSizePreset': '預設',
	'propPageSizePresetCustom': '自訂',
	'propPageSizePreset16x9': '畫面 16:9',
	'propPageSizePreset4x3': '畫面 4:3',
	'propPageSizePresetInfographic': '資訊圖表',
	'propPageSizeWidth': '寬度',
	'propPageSizeHeight': '高度',
	'propPageSizeWidthAriaLabel': '頁面大小寬度',
	'propPageSizeHeightAriaLabel': '頁面大小高度',
	'propPageSizeAdjustedMessage': '頁面大小已增加，因為您的項目低於下限或不符合您的儀表板。',
	'propTabShow': '顯示標籤',
	'propShowTabsInPreview': '以預覽來顯示標籤',
	'multilingualDashboardsLabel': '語言',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- 預設值',
	'multilingualDashboardsAddLinkText': '新增另一個語言',
	'multilingualDashboardsSelect': '選取',
	'multilingualDashboardsButtonLabel': '新增',
	'multilingualDashboardTranslationMode': '您現在處於翻譯模式 (%{currentLanguage})',
	'multilingualDashboardTranslationDone': '完成',
	'multilingualDashboardRemainingStrings': '剩餘 %{numTranslationsLeft} 個翻譯',
	'multilingualDashboardRemainingString': '剩餘 1 個翻譯',
	'multilingualDashboardsSetDefault': '設定預設語言',
	'multilingualDashboardIconMore': '語言 %{currentLanguage} 的其他動作',
	'multilingualDashboardIconTranslatableArea': '可翻譯區',
	'multilingualDeleteTitle': '刪除語言',
	'multilingualDeleteLanguageWarning': '您確定要刪除語言 \'%{language}\' 嗎？',
	'multilingualSelectLanguage': '選取語言',
	'confirmLayoutStyleUpgradeTitle': '套用至所有標籤',
	'confirmLayoutStyleUpgrade': '將此佈置樣式套用至儀表板中的所有標籤？',

	//Tabs
	'tabDeleteDialogPrimaryButton': '刪除',
	'tabDeleteDialogTitle': '要刪除此標籤嗎？',
	'tabDeleteDialogMessage': '也會刪除此標籤上的所有內容。',

	// Vis widget
	'propVisTypeReturn': '視覺化類型',
	'propVisDetails': '詳細資料',

	// Alignment picker
	'propAlignPickTop': '靠上對齊',
	'propAlignPickRight': '靠右對齊',
	'propAlignPickBottom': '靠下對齊',
	'propAlignPickLeft': '靠左對齊',
	'propAlignPickCenter': '置中對齊',
	'propAlignPicker': '對齊方式',

	// Toolbar picker
	'propToolbarPickBold': '粗體',
	'propToolbarPickUnderline': '底線',
	'propToolbarPickItalic': '斜體',
	'propToolbarPickJustifyLeft': '靠左對齊',
	'propToolbarPickJustifyCenter': '置中對齊',
	'propToolbarPickJustifyRight': '靠右對齊',
	'propToolbarPickJustify': '整理版面',

	'propList': '清單',
	'propOrderedList': '排序的清單',
	'propUnorderedList': '未排序的清單',

	// Symbol shapes
	'propCircle': '圓形',
	'propTriangle': '三角形',
	'propSquare': '方形',
	'propRect': '矩形',
	'propStar': '星形',
	'propCross': '十字型',
	'propPlus': '加號',
	'propPoly': '多邊形',


	// True and false selection
	'propTrue': 'True',
	'propFalse': 'False',

	// Position selection
	'propLeft': '左',
	'propRight': '右',
	'propTop': '上',
	'propBottom': '下',

	// Interpolation options
	'propSmooth': '平滑',
	'propStraight': '筆直',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': '清單', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': '左移', // screen reader
	'srWidgetMoveUp': '上移', // screen reader
	'srWidgetMoveRight': '右移', // screen reader
	'srWidgetMoveDown': '下移', // screen reader

	// widget resize
	'srWidgetResizeBigger': '增加比例大小', // screen reader
	'srWidgetResizeSmaller': '減少比例大小', // screen reader
	'srWidgetResizeBiggerV': '增加垂直大小', // screen reader
	'srWidgetResizeSmallerV': '減少垂直大小', // screen reader
	'srWidgetResizeBiggerH': '增加水平大小', // screen reader
	'srWidgetResizeSmallerH': '減少水平大小', // screen reader

	// widget rotate
	'srWidgetRotateCW': '順時針方向旋轉', // screen reader
	'srWidgetRotateCCW': '逆時鐘方向旋轉', // screen reader

	// Recommended types
	'visChange': '變更視覺化',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': '視覺化',
	'chartLabel': '%{chartName} 圖表',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': '按 F12 在小組件內進行導覽',
	'f10KeyDescription': '按 F10 以啟動小組件焦點視圖',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{label} 的值為 %{value}',

	'shapeColorLabel': '形狀顏色',
	'showLegendLabel': '顯示圖註',

	//Webpage
	'webpageWidgetTitle': '網頁小組件',
	'webpagePasteLink': '貼上 URL，然後按 Enter 鍵來進行儲存。',
	'propWebpageLink': '網頁 URL',
	'propWebpageTitle': '網頁標題',
	'propWebpageTitleDescription': '網頁標題',
	'webpageUrl': '網頁 URL',
	'noWebpageSelected': '未選取任何網頁',
	'enterWebpageUrl': '在這裡輸入網頁 URL',
	'propWebpageTop': '網頁內容', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': '網頁 URL 遺漏。',
	'webpageUrlValidationError': '網頁 URL 無效。',
	'webpageHttpValidationError': '必須使用 HTTPS 鏈結存取網頁。',
	'webpageInvalidDomainError': '此網頁 URL 指向尚未由管理者核准的網域。由管理者核准的網域為 "%{domains}"。',

	//VizState
	'vzErrorLoading': '無法載入視覺化',
	'vzErrorLoadingMissingData': '無法載入視覺化，遺漏環境定義資料',

	//Media (Video / Audio)
	'mediaWidgetTitle': '媒體小組件',
	'mediaPasteLink': '貼上 URL，然後按 Enter 鍵來進行儲存。',
	'mediaUrl': '媒體 URL',
	'noMediaSelected': '未選取任何媒體',
	'enterMediaUrl': '在這裡輸入媒體 URL',
	'videoHeight': '高度：',
	'videoWidth': '寬度：',
	'propMediaLink': '媒體鏈結',
	'propMediaTitle': '媒體標題',
	'propMediaTitleDescription': '媒體標題',
	'propMediaTop': '媒體內容', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': '媒體鏈結 URL 遺漏。',
	'mediaUrlValidationError': '媒體檔案 URL 無效。',
	'mediaUnknownValidationError': '不支援此媒體類型。',
	'mediaHttpValidationError': '必須使用 HTTPS 鏈結存取媒體檔案。',
	'mediaInvalidDomainError': '此媒體檔案 URL 指向尚未由管理者核准的網域。由管理者核准的網域為 "%{domains}"。',

	// Properties pane
	'commonPropertiesLabel': '內容', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': '資料集',
	'dataViewsLabel': '檢視',
	'columnQuality': '資料品質',
	'columnProperties': '資料內容',

	'dataQuality': '資料品質',
	'dataQualityRowCount': '列數',
	'dataQualityDistribution': '配送',
	'dataRowLabel': '資料',

	// Modelling UI
	'typeColumn': '類型',
	'modellingColumnType': '類型',
	'modellingColumnAggregation': '聚集',
	'modellingColumnUsage': '用法',
	'modellingColumnSort': '排序',
	'modellingColumnFormat': '格式',
	'modellingColumnCategory': '種類',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': '載入中...',

	'modellingProcessing': '處理中...',
	'modellingImport': '匯入',
	'modellingReimport': '重新匯入',
	'modellingDatasourceTitle': '資料來源',
	'modellingImportStartedTitle': '已開始匯入',
	'modellingImportStartedText': '匯入您的資料可能需要花費一些時間。\n\n（您可以在資料匯入時建立視圖。）',
	'importDatasourceTitle': '連線',
	'dropHere': '拖放至此處來建立新的資料來源...',
	'browseButton': '瀏覽',
	'errorNoData': '沒有要處理的資料。',
	'errorNoFile': '沒有要上傳的檔案。',
	'errorUploadFailed': '無法上傳。',
	'uploadSucceessful': '上傳成功',
	'del_datasourceTitle': '刪除資料集',
	'del_datasourceMsg': '您確定要刪除 \'%{name}\' 嗎？',
	'modellingFileUpdate': '更新',
	'modellingFileUpdateTitle': '更新資料集',
	'modellingFileUpdateDescription': '您想要更新 \'%{name}\' 嗎？',
	'modellingFileUpdatingTitle': '更新 \'%{name}\'',
	'modellingUpdateStartedTitle': '已開始更新匯入',
	'modellingUpdateStartedText': '匯入您的資料可能需要花費一些時間。\n\n（您可以在資料更新時建立視圖。）',
	'modellingErrorImportUploadNoFile': '沒有要上傳的檔案。',
	'modellingErrorImportUploadFailed': '無法上傳。',
	'modellingErrorImportUploadInvalidType': '檔案類型無效。',
	'modellingErrorImportUploadTableFailed': '無法取得表格。',
	'modellingIntentResultsTitle': '選取要使用的提出資料集',
	'modellingColumnViewRelationships': '檢視相關的表格',
	'modellingTableRelatedTables': '與 \'%{name}\' 相關的表格',
	'modellingTable': '%{name} - 表格',
	'modellingColumnIncludedInDataSet': '已新增',
	'modellingDataSet': '資料集',
	'modellingViewInDataSet': '資料集中的視圖',
	'modellingViewRelatedTables': '相關視圖',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': '找不到相關的表格',

	'modellingValidatingDataset': '驗證...',
	'datasetFinishedRefreshing': '已重新整理資料集 %{datasetName}。',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': '解析結合路徑：',
	'modellingJoinColumns': '定義表格的結合路徑：%{name}',
	'modellingJoinToTable': '結合至表格：%{name}',

	// Data Quality
	'excluded': '已排除',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': '過濾',
	'modellingColumnSortNone': '清除排序',
	'modellingColumnSortAsc': '遞增排序',
	'modellingColumnSortDesc': '遞減排序',
	'modellingColumnRemove': '移除此直欄',

	// Import File Browser
	'dropboxPageTitle': '新的 Dropbox 連線',
	'sizeColumn': '大小',

	//Modelling Column Property Values
	'dataType_string': '字串',
	'dataType_date': '日期',
	'dataType_integer': '整數',
	'dataType_double': '倍精準數',
	'dataType_float': '浮點',
	'dataType_boolean': '布林',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': '計數',
	'defaultAggregation_countdistinct': '相異計數',
	'defaultAggregation_max': '最大值',
	'defaultAggregation_min': '最小值',
	'defaultAggregation_avg': '平均值',
	'defaultAggregation_sum': '總和',
	'defaultAggregation_auto': '自動 (%{aggregationType})',

	'type_fact': '數據',
	'type_attribute': '屬性',

	'defaultSort_none': '請勿排序',
	'defaultSort_asc': '遞增排序',
	'defaultSort_desc': '遞減排序',

	'category_none': '無',
	'category_location': '位置',
	'category_monetary': '貨幣',
	'category_time': '時間',

	// Root menu
	'rootMenuTitle': '主功能表',

	'errorMessageTitle': '錯誤',
	'errorMessageDetails': '詳細資料：',
	'errorMessageTitleAssetAlreadyExists': '資產已存在',

	'defaultTabTitle': '標籤 %{index}',
	'tabAddBtnTitle': '新增標籤',

	'unsupportedConditionalFormattingEncountered': '條件式格式不再套用至某些直欄。',


	// Homepage View
	'nameColumn': '名稱',
	'creatorColumn': '建立者',
	'creationDateColumn': '建立日期',
	'versionColumn': '版本',
	'modifiedColumn': '前次修改時間',

	'filterBy': '過濾項目',
	'allFilter': '所有項目',
	'createdByMeFilter': '由我建立',
	'sharedWithMeFilter': '與我共用',
	'favoritesFilter': '我的最愛',
	'recentsFilter': '最近新增',
	'sortBy': '排序方式',

	// Sort Menu
	'sortModified': '已修改',
	'sortUpdated': '已更新',
	'sortName': '名稱',

	'viewAs': '以下列方式檢視',
	'thumbnailsView': '檢視縮圖',
	'listView': '以清單檢視',
	'createMenu': '建立',
	'newAppItem': '儀表板',
	'newDataSet': '資料集',

	'menuSelectionState_a11y': '"%{item}" 選取器設為 "%{selectedItem}"',

	'unableToShareItem': '無法共用項目 "%{item}"。',
	'toastFetchingContent': '取得更多內容...',
	'unableToGetData': '無法取得內容。',
	'unableToFavorite': '無法變更「我的最愛」狀態。',
	'hpErrorMissingRequiredOptions': '遺漏需要的起始設定選項',
	'unableToOpenBoard': '無法開啟 "%{name}"。',
	'unableToDuplicateBoard': '無法複製 "%{name}"。',
	'unableToCreateBoard': '無法建立 "%{name}"。',
	'unableToCreateBoardNameConflict': '已有同名的資產。',

	// DataSet Detail View
	'status': '狀態',
	'numberOfRows': '列數',
	'importWarnings': '警告',
	'lineNumbers': '行數',
	'excerptFromSource': '摘錄',
	'reason': '原因',
	'numberOfRowsDropped': '捨棄的列數',
	'oneRowDropped': '已捨棄 1 列',

	// Type Menu
	'typeMenuLabel': '類型',
	'dashboardsLabel': '儀表板',
	'datasetsLabel': '資料集',
	'storiesLabel': '案例',
	'allLabel': '所有類型',

	// Board Page View App Bar
	'datasets': '資料集',
	'settings': '內容',
	'add': '新增',
	'widgets': '小組件',
	'dashboardProperties': '儀表板內容',
	'searchPanel' : '搜尋',
	'pins': '集合',
	'pinsOld': '我的固定項目',
	'pinsDateFilterHeading' : '固定日期',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} 個固定項目 |||| %{smart_count} 個固定項目',
	'pinSearch': '搜尋',
	'pinSearchOld': '搜尋固定項目',
	'pinListView': '清單視圖',
	'pinIconView': '圖示視圖',
	'pinRemove': '移除',
	'pinCreate': '建立',
	'pinDeleteError': '我們無法刪除集合中的一個以上資產。 請稍後重試。',
	'pinDeleteErrorOld': '我們無法刪除一個以上固定項目。 請稍後重試。',
	'pinRetrieveError': '我們無法擷取一個以上的固定項目。請稍後重試。',
	'NoPinsCollected': '無固定項目視覺化',
	'pinDeletedToast': '已移除固定項目',
	'pinAddedToast': '固定項目已順利新增至我的固定項目',
	'pinningToast': '正在處理固定項目...',
	'pinDateFilter': '日期過濾器',
	'pinDateFilterAll': '全部',
	'pinDateFilterToday': '今天',
	'pinDateFilterYesterday': '昨天',
	'pinDateFilterPastWeek': '上週',
	'pinDateFilterPastMonth': '上個月',
	'pinDateFilterEarlier': '更早',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': '編輯標題',
	'toolbarActionSort': '排序',
	'toolbarActionSortAscending': '遞增排序',
	'toolbarActionSortDescending': '遞減排序',
	'toolbarActionSortAuto': '自動 (%{sortOrder})',
	'toolbarActionFormat': '格式資料',
	'toolbarActionFormatAbbreviation': '縮寫',
	'toolbarActionFormatNone': '自動',
	'toolbarActionFilter': '過濾',
	'toolbarActionTopBottom': '最前或最後',
	'toolbarActionAddShape': '新增形狀',
	'toolbarActionRmvShape': '移除形狀',
	'toolbarActionToggleShapeDrop': '資訊圖表形狀',
	'toolbarActionToggleShapeDropTitle': '建立資訊圖表',
	'toolbarActionToggleShapeDropText': '將形狀拖曳至此欄位以建立資訊圖表。',
	'toolbarActionAggregationType': '彙總',
	'toolbarDeleteActionText': '移除直欄',
	'toolbarActionFilterLocalKeepSelected': '保留',
	'toolbarActionFilterLocalExcludeSelected': '排除',
	'toolbarActionFilterAllKeepSelected': '過濾',
	'toolbarActionSimpleCalculation': '簡式計算',
	'toolbarActionDrillBack': '返回',
	'toolbarActionDrillUp': '向上逐層分析',
	'toolbarActionDrillDown': '向下逐層分析',
	'toolbarActionNavigate': '導覽',
	'toolbarActionCreateFilterGroup': '建立新連線',
	'toolbarActionDisconnectFilterGroup': '斷開所有鏈結',
	'toolbarActionLinkFilterGroup': '新增至現有的連線',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': '新增',
	'sidebarMultiselect': '切換多重選項',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '已選取 %{count} 個',

	'multiselectWithTotalMsg': '%{count} 個（共 %{total} 個）',
	'sidebarGoBack': '回上頁',

	//DataSet pane
	'errorLoadingDataSets': '我們無法載入此資料集',
	'errorLoadingDataSetMetaData': '我們無法載入此資料集',
	'dataSetPaneLastUpdated': '前次更新日期：%{date}',
	'dataSetPaneDateUnknown': '不明',
	'sourcePaneLabel': '選取的來源',
	'addSourceLabel': '新增來源',
	'find_label': '尋找',
	'navigationPathsLabel': '導覽路徑',

	//widgetlist
	'errorLoadingWidgetList': '我們無法載入物件。',
	'errorLoadingThemeFile': '我們無法載入佈景主題定義。',
	'errorLoadingLayoutFile': '我們無法載入視圖。',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': '我們無法載入可用的視覺化定義。',

	'dwErrorLoadingVisualizationNotFound': '我們無法載入物件，因為它遺漏視覺化定義。',
	'dwErrorLoadingVisualizationListNotFound': '我們無法載入視覺化。',
	'dwErrorRunningQuery': '無法從資料集 %{datasetName} 中擷取資料。',
	'dwErrorGeoData': '顯示對映中的地理資料時發生困難。請選擇另一種視覺化類型。',
	'dwPromptSignonCancelWarning': '此視覺化的資料無法使用。 請提供正確認證。',
	'dwErrorMissingDataset': '無法載入視覺化，因為無法使用其關聯的資料集 \'%{datasetName}\'。',
	'dwErrorRenderingVisualization': '我們無法載入此視覺化。',
	'dwErrorVisualizationTooSmall': '視覺化太小，無法顯示其所含的資料。請設定較大的視覺化，或限制其所含的資料。',
	'aria_label_datatable': '資料表',
	'aria_key_navi_datatable_desc': '使用方向鍵以導覽至每一個儲存格。按 Ctrl 鍵和 Home 鍵以移至第一列，按 Ctrl 鍵和 End 鍵以移至最後一列。',
	'geomapUnrecognizedLocations': '無法辨識的位置：',
	'geomapAmbiguousLocations': '不明確區域：',

	// custom widget
	'customWidget': '自訂小組件',
	'customWidgetsTitle': '自訂小組件',
	'noCustomWidgets': '無自訂小組件',

	// Action names
	'toggleContextBar': '切換環境定義列',
	'delete': '刪除',
	'share': '共用',
	'unshare': '解除共用',
	'rename': '重新命名',
	'close': '關閉',
	'duplicate': '複製',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': '重試',

	'changeTemplate': '變更範本',

	// Aggregation Types
	'sum': '總和',
	'count': '計數',
	'countdistinct': '相異計數',
	'avg': '平均值',
	'min': '最小值',
	'max': '最大值',
	'custom': '自訂',
	'calculated': '計算',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '變更百分比',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': '視覺化準則...',
	'QuickAddResultsHeader': '資料視覺化',
	'NoQuickAddResults': '沒有任何項目符合您的目的。要建立新的資料集嗎？',
	'NoQuickAddResultsRetry': '我們找不到任何相符項。請使用不同術語來重試。',
	'templateWidgetTitle': '範本',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '（空白）',

	'nullValueContent': '（沒有值）',
	'nullValueText': '空值',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': '文字過濾器 - %{columnName}',

	'textFilterSelectTab': '選取',

	'textFilterConditionTab': '設定條件',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': '無法使用項目。',

	'textFilterEquals': '等於',
	'textFilterContains': '包含',
	'textFilterBeginsWith': '開始於',
	'textFilterEndsWith': '結束於',
	'textFilterDoesNotEqual': '不等於',
	'textFilterDoesNotContain': '不包含',
	'textFilterDoesNotBeginWith': '不是開始於',
	'textFilterDoesNotEndWith': '不是結束於',
	'textFilterSampleText': '例如：A',

	'textFilterAndButton': '和',
	'textFilterOrButton': '或',

	'dateFilterMessage': '選取日期範圍',
	'dateRangeControlRegionLabel': '日期範圍過濾器 - %{columnName}',
	'dateFilterRangeOption': '範圍選項',
	'dateFilterDateLabel': '日期',
	'dateFilterBlank': '（空白）',
	'dateFilterBefore': '之前',
	'dateFilterAfter': '之後',
	'dateFilterBetween': '介於',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': '日期',
	'dateIncludeBlankLabel': '包括空白日期',

	'timeTitle': '時間',
	'timeFilterMessage': '請選取時間範圍',
	'dateTimeFilterMessage': '請選取日期和時間範圍',

	'topbottomNumberOfResultsLabel': '結果數',
	'topbottomPercentLabel': '百分比',
	'topbottomNumberOfResultsLimit': '介於 %{lower}-%{higher} 之間',
	'topbottomSelectOption': '最前或最後選項',
	'topbottomOptionLabel': '顯示',
	'searchByLabel': '依據',
	'searchNoMatches': '找不到任何相符項',
	'topbottomRankColumnLabel': '新增排名直欄至表格',
	'topbottomNone': '無',
	'topCount': '最高計數',
	'topPercent': '最高百分比',
	'bottomCount': '最低計數',
	'bottomPercent': '最低百分比',
	'topbottomSearchColumn': '尋找直欄',
	'searchColumnAriaLabel': '尋找直欄。鍵入要搜尋的直欄名稱，然後使用下移鍵尋找清單中的該直欄',
	'rankColumnLabel': '等級 (%{columnLabel})',
	'topbottomClearLabel': '清除',

	'rangeFilterControlRegionLabel': '範圍過濾器 - %{columnName}',

	// Slider
	'sliderRegionLabel': '滑塊控制項，使用右移鍵和左移鍵來移動滑塊處理程式',
	'sliderHandleLabel': '滑塊處理程式',
	'a11ySliderHandleLabel': '滑塊處理程式 %{sliderValue}',
	'sliderInputLabel': '值',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': '此視覺化中所使用的某些資料集項目無法使用。',
	'datasetItemUnavailable': '此資料集項目無法使用',

	//Authoring topBottom
	'topOperator': '上',
	'bottomOperator': '下',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{operator} %{value} 個〈依 %{columnLabel}）',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': '僅此物件',
	'deleteTopBottom': '刪除最前或最後計數',
	'editTopBottom': '編輯最前或最後計數',
	'deleteDrillState': '刪除現行逐層分析狀態',
	'ariaDeleteDrillStateLabel': '按 ENTER 鍵來編輯最前或最後計數。',
	'drillUpStateTitle': '向上逐層分析',
	'drillDownStateTitle': '向下逐層分析',
	'ariaEditTopBottomLabel': '按 ENTER 鍵來編輯最前或最後計數。',
	'ariaDeleteTopBottomLabel': '按 DELETE 鍵來刪除最前或最後計數。',

	// Authoring filtering
	'dimFilterIn': '併入項目：%{in}',
	'dimFilterNotIn': '排除項目：%{out}',
	'measureFilterBetween': '介於 %{lowerBound} 到 %{upperBound} 之間',
	'measureFilterNotBetween': '未介於 %{lowerBound} 到 %{upperBound} 之間',
	'gtFilter': '在 %{lowerBound} 之後',
	'ltFilter': '在 %{upperBound} 之前',
	'notGtFilter': '不在 %{lowerBound} 之後',
	'notLtFilter': '不在 %{upperBound} 之前',
	'localFilterTitle': '僅此物件',
	'globalFilterTitle': '所有物件',
	'deleteFilter': '刪除過濾器',
	'editFilter': '編輯過濾器',
	'ariaEditFilterLabel': '按 ENTER 鍵來編輯過濾器。',
	'ariaDeleteFilterLabel': '按 DELETE 鍵來刪除過濾器。',

	// Prompts
	'ariaEditPrompt': '按 ENTER 鍵以變更提示值',

	'moreDataIndicator': '在 %{threshold} 項目上，資料已被裁切。請套用過濾器以精簡顯示。',

	// data point filtering
	'dataPointFilterTitle': '資料點',
	'dataPointFilterIncludeSummary': '已包含 %{valueCount} 個資料點',
	'dataPointFilterExcludeSummary': '已排除 %{valueCount} 個資料點',

	// DB2 connection page
	'db2Database': 'DB2 資料庫 (%{jdbcConnection})',
	'db2Title': '連接至 IBM Db2',

	// Database
	'databaseConnectionMessage': '提供您的資料庫連線詳細資料：',
	'connectionString': '資料庫連線字串',
	'databaseCredentials': '認證：',
	'databaseUserName': '使用者名稱',
	'databasePassword': '密碼',
	'databaseConnect': '連接',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': '輸入搜尋詞彙：',
	'twitterKeyword': '關鍵字',
	'twitterSearch': '搜尋',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'Db2',

	'workbookCreateFailed': '我們無法建立視圖：%{error}\n失敗的作業：%{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': '小組件過濾器',
	'missingColumn': '遺漏：%{columnLabel}',
	'missingFiltering': '遺漏下列直欄 ID 上的過濾器：',
	'heatByLabel': '熱度依據',
	'evColumns': '直條圖',
	'evLocalFilters': '本端過濾器',
	'evExpand': '展開',
	'evFilterTooltip': '過濾',
	'evAdd': '新增直欄',

	// Navigation View
	'navigationBack': '返回',

	// Pinning
	'contentPinFail': '我們無法收集內容。請稍後重試。',
	'contentPinFailOld': '我們無法固定內容。請稍後重試。',

	// Layouts
	'dropZoneLabel': '在這裡放下來進行最大化',

	//Share
	'shareDefaultPageTitle': '第 %{index} 頁',

	'nextPage': '下一頁',
	'previousPage': '上一頁',

	'assetAssembly': '視圖',

	'toolbar_save': '儲存',
	'brgr_saveAs': '另存新檔',
	'brgr_refresh': '重新整理',

	// Save
	'saving': '儲存中...',
	'save_success': '已儲存您的視圖。',
	'save_failure': '抱歉。無法儲存您的視圖。請稍後重試。',
	'dashboard_save_success': '已儲存您的儀表板。',

	'geminiLeave': '您即將離開 IBM Watson Analytics。',

	'warning': '警告',
	'missingDataSetData': '此資料集的資料無法使用。請重新整理此資料集，或聯絡管理者以取得來源的存取權。',

	// Calculations
	'error_calculation_in_use': '選取的計算已在使用中，無法刪除。',

	'resize': '調整大小',
	'rotate': '旋轉',
	'moveHandle': '移動小組件',
	'expandHandle': '展開',
	'panHandle': '平移',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': '導覽至',

	// Slide out titles
	'shapeSlideoutTitle': '形狀',
	'textSlideoutTitle': '文字',
	'mediaSlideoutTitle': '媒體',
	'visualizationSlideoutTitle': '視覺化',

	// Board Model Dialog Messages
	'invalidJSONResponse': '提供的 JSON 無效。如需相關資訊，請參閱錯誤日誌。',

	// Widget type labels
	'shape_label': '形狀',
	'image_label': '影像',
	'data_label': '圖表',
	'media_label': '媒體',
	'text_label': '文字',
	'embedMedia_label': '媒體',
	'youtube_label': 'YouTube 影片',
	'webpage_label': '網頁',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': '形狀',
	'noExtraText_shape_numbered': '形狀 (%{number})',
	'few_shape': '%{count} 個形狀的群組',
	'many_shape': '%{count} 個形狀的群組',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} 影像',
	'one_image_numbered': '%{text} 影像 (%{number})',
	'noExtraText_image': '影像',
	'noExtraText_image_numbered': '影像數 (%{number})',
	'few_image': '%{count} 個影像的群組',
	'many_image': '%{count} 個影像的群組',
	'noExtraText_text': '空的文字框',
	'noExtraText_text_numbered': '空的文字框 (%{number})',
	'few_text': '%{count} 個文字框的群組',
	'many_text': '%{count} 個文字框的群組',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube Viewer',
	'pacubeviewer_named': '%{name} Cube Viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{values} 個依 %{row_level1} 和 %{column_level1} 的交叉資料表',
	'crosstab_opt_mapping_numbered': '%{values} 個依 %{row_level1} 和 %{column_level1} (%{number}) 的交叉資料表',
	'crosstab_has_mapping': '%{values} 個依 %{row_level1} 的交叉資料表',
	'crosstab_has_mapping_numbered': '%{values} 個依 %{row_level1} (%{number}) 的交叉資料表',
	'crosstab_no_mapping': '空的交叉資料表',
	'crosstab_no_mapping_numbered': '空的交叉資料表 (%{number})',
	'crosstab_named': '%{name} 交叉資料表',
	'crosstab_named_numbered': '%{name} 交叉資料表 (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} 表格',
	'JQGrid_has_mapping_numbered': '%{grid_cols} 表格 (%{number})',
	'JQGrid_no_mapping': '空的表格',
	'JQGrid_no_mapping_numbered': '空的表格 (%{number})',
	'JQGrid_named': '%{name} 表格',
	'JQGrid_named_numbered': '%{name} 表格 (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} 階層',
	'hierarchy_has_mapping_numbered': '%{level1} 階層 (%{number})',
	'hierarchy_no_mapping': '空的階層',
	'hierarchy_no_mapping_numbered': '空的階層 (%{number})',
	'hierarchy_named': '%{name} 階層',
	'hierarchy_named_numbered': '%{name} 階層 (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} 地圖',
	'map_has_mapping_numbered': '%{categories} 地圖 (%{number})',
	'map_no_mapping': '空的地圖',
	'map_no_mapping_numbered': '空的地圖 (%{number})',
	'map_named': '%{name} 地圖',
	'map_named_numbered': '%{name} 地圖 (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} 摘要值',
	'summary_has_mapping_numbered': '%{actual} 摘要值 (%{number})',
	'summary_no_mapping': '空的摘要值',
	'summary_no_mapping_numbered': '空的摘要值 (%{number})',
	'summary_named': '%{name} 摘要值',
	'summary_named_numbered': '%{name} 摘要值 (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{actual}（依 %{sparkline.time}）KPI',
	'kpi_opt_mapping_numbered': '%{actual}（依 %{sparkline.time}）KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': '空的 KPI',
	'kpi_no_mapping_numbered': '空的 KPI (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} 資訊圖',
	'infographicSummary_has_mapping_numbered': '%{actual} 資訊圖 (%{number})',
	'infographicSummary_no_mapping': '空的資訊圖',
	'infographicSummary_no_mapping_numbered': '空的資訊圖 (%{number})',
	'infographicSummary_named': '%{name} 資訊圖',
	'infographicSummary_named_numbered': '%{name} 資訊圖 (%{number})',
	'noExtraText_youtube': 'YouTube 影片',
	'noExtraText_youtube_numbered': 'YouTube 影片 (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} YouTube 影片',
	'one_youtube_numbered': '%{text} YouTube 影片 (%{number})',
	'few_youtube': '%{count} 個 YouTube 影片的群組',
	'many_youtube': '%{count} 個 YouTube 影片的群組',
	'noExtraText_embedMedia': '媒體鏈結',
	'noExtraText_embedMedia_numbered': '媒體鏈結 (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} 媒體鏈結',
	'one_embedMedia_numbered': '%{text} 媒體鏈結 (%{number})',
	'few_embedMedia': '%{count} 個媒體鏈結的群組',
	'many_embedMedia': '%{count} 個媒體鏈結的群組',
	'noExtraText_media': '媒體',
	'noExtraText_media_numbered': '媒體 (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} 媒體',
	'one_media_numbered': '%{text} 媒體 (%{number})',
	'few_media': '%{count} 個媒體的群組',
	'many_media': '%{count} 個媒體的群組',
	'noExtraText_webpage': '網頁',
	'noExtraText_webpage_numbered': '網頁 (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} 網頁',
	'one_webpage_numbered': '%{text} 網頁 (%{number})',
	'few_webpage': '%{count} 個網頁的群組',
	'many_webpage': '%{count} 個網頁的群組',
	'one_unknown': '一個物件',
	'one_unknown_numbered': '物件 (%{number})',
	'few_unknown': '%{count} 個物件的群組',
	'many_unknown': '%{count} 個物件的群組',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': '下一步',
	'previous': '上一步',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': '現行導覽群組為 %{navigation_group_name}',

	//Page Context
	'filterBlank': '（空白）',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': '無法載入過濾器值',
	'editTimelineHighlight': '編輯強調顯示',

	'filterDockChevronLeft': '捲動瀏覽資料',
	'filterDockChevronRight': '捲動瀏覽資料',
	'expand': '展開',
	'collapse': '收合',

	//Reset Dashboard
	'dashboardResetTitle': '重設儀表板',
	'dashboardResetMessage': '您確定要重設套用至此儀表板的所有變更嗎？',
	'dashboardResetToast': '您的儀表板已重設。',

	//Generate PDF
	'buildingPDF': '正在建置 PDF...',
	'exportPDF': '匯出成 PDF',
	'pageSize': '頁面大小',
	'orientation': '方向',
	'filtersPresentPDF': '套用至前一個頁面上之視覺化的過濾器：',
	'errorPDF': '無法產生 PDF。請重新整理，然後再試一次。',
	'printPDFInfo': '檢視文件',
	'pdfWidget': '小組件',
	'includeFilters': '顯示過濾器詳細資料',
	'portrait': '直印',
	'landscape': '橫印',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': '已升級您的儀表板。立即儲存以維護最佳效能。',

	'ariaFullScreenMessage': '按 Esc 鍵以結束全螢幕',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} 壓縮階層泡泡圖',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} 壓縮階層泡泡圖 (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': '空的壓縮階層泡泡圖',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': '空的壓縮階層泡泡圖 (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} 壓縮階層泡泡圖',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} 壓縮階層泡泡圖 (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{categories}（依 %{values}）馬賽克圖',
	'LIVE_marimekko_has_mapping_numbered': '%{categories}（依 %{values} 馬賽克圖）(%{number})',
	'LIVE_marimekko_no_mapping': '空的 marimekko 圖',
	'LIVE_marimekko_no_mapping_numbered': '空的馬賽克圖 (%{number})',
	'LIVE_marimekko_named': '%{name} 馬賽克圖',
	'LIVE_marimekko_numbered': '%{name} 馬賽克圖 (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} 放射環狀圖',
	'LIVE_sunburst_has_mapping_numbered': '%{values} 放射環狀圖 (%{number})',
	'LIVE_sunburst_no_mapping': '空的放射環狀圖',
	'LIVE_sunburst_no_mapping_numbered': '空的放射環狀圖 (%{number})',
	'LIVE_sunburst_named': '%{name} 放射環狀圖',
	'LIVE_sunburst_named_numbered': '%{name} 放射環狀圖 (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} 動因分析圖表',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} 動因分析圖表 (%{number})',
	'LIVE_decision_analysis_no_mapping': '空的動因分析圖表',
	'LIVE_decision_analysis_no_mapping_numbered': '空的動因分析圖表 (%{number})',
	'LIVE_decision_analysis_named': '%{name} 動因分析圖表',
	'LIVE_decision_analysis_named_numbered': '%{name} 動因分析圖表 (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{categories}（依 %{columnValue} 和 %{lineValue}）折線圖和直條圖',
	'LIVE_line_column_opt_mapping_numbered': '%{categories}（依 %{columnValue} 和 %{lineValue}）折線圖和直條圖 (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} 和 %{lineValue} 折線圖和直條圖',
	'LIVE_line_column_has_mapping_numbered': '%{categories}（依 %{columnValue} 和 %{lineValue}）折線圖和直條圖 (%{number})',
	'LIVE_line_column_no_mapping': '空的折線圖與直條圖',
	'LIVE_line_column_no_mapping_numbered': '空的折線圖和直條圖 (%{number})',
	'LIVE_line_column_named': '%{name} 折線圖和直條圖',
	'LIVE_line_column_named_numbered' : '%{name} 折線圖和直條圖 (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{x}（依 %{y} 和 %{size}）泡泡圖',
	'LIVE_bubble_chart_has_mapping_numbered': '%{x}（依 %{y} 和 %{size}）泡泡圖 (%{number})',
	'LIVE_bubble_chart_no_mapping': '空的泡泡圖',
	'LIVE_bubble_chart_no_mapping_numbered': '空的泡泡圖 (%{number})',
	'LIVE_bubble_chart_named': '%{name} 泡泡圖',
	'LIVE_bubble_chart_named_numbered': '%{name} 泡泡圖 (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} 重點式圖表',
	'LIVE_bullet_has_mapping_numbered': '%{actual} 重點式圖表 (%{number})',
	'LIVE_bullet_no_mapping': '空的重點式圖表',
	'LIVE_bullet_no_mapping_numbered': '空的重點式圖表 (%{number})',
	'LIVE_bullet_named': '%{name} 重點式圖表',
	'LIVE_bullet_named_numbered': '%{name} 重點式圖表 (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': '依下列依據來提供此儀表板的資料',
	'showFooterToggleButtonText': '顯示標底',
	'showFooterSectionText': '標底'
});
